import { render, staticRenderFns } from "./UnitProductRemove.vue?vue&type=template&id=2ebd7033&"
import script from "./UnitProductRemove.vue?vue&type=script&lang=js&"
export * from "./UnitProductRemove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ebd7033')) {
      api.createRecord('2ebd7033', component.options)
    } else {
      api.reload('2ebd7033', component.options)
    }
    module.hot.accept("./UnitProductRemove.vue?vue&type=template&id=2ebd7033&", function () {
      api.rerender('2ebd7033', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ShopSetting/Pages/Product/components/Unit/UnitProductRemove.vue"
export default component.exports